import { LANGUAGE_SET } from "../constants/languageConstants";

/* Remembered only for the current browser session, per spec — not
   localStorage, which would survive a browser restart. */
export const setLanguage = (code) => (dispatch) => {
  dispatch({
    type: LANGUAGE_SET,
    payload: code,
  });

  sessionStorage.setItem("tablify_lang", code);
};
